<template>
  <div>
    <div class="filter-list">
      <div class="filter-item middle-filter-item">
        <div class="item-label">
          子流程
        </div>
        <div class="item-component">
          <div class="el-select-wrapper kpi-type-select-wrapper">
            <el-select v-model="filter.subProcess.value" clearable placeholder="请选择" filterable
                       @change="onsubProcessChange">
              <el-option v-for="item in filter.subProcess.options" :key="item.srcId" :value="item.srcId"
                         :label="item.name"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="filter-item small-filter-item">
        <div class="item-label">
          子流程状态
        </div>
        <div class="item-component">
          <div class="el-select-wrapper kpi-type-select-wrapper">
            <el-select v-model="filter.subProcessStatus.value" clearable placeholder="请选择" filterable
                       @change="onsubProcessStatusChange">
              <el-option v-for="item in filter.subProcessStatus.options" :key="item.code" :value="item.code"
                         :label="item.name" :class="$util.getRiskLevelBgColor(item.color)"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="filter-item middle-filter-item">
        <div class="item-label">
          节点
        </div>
        <div class="item-component">
          <div class="el-select-wrapper kpi-type-select-wrapper">
            <el-select v-model="filter.node.value" clearable placeholder="请选择" filterable @change="onNodeChange">
              <el-option v-for="item in filter.node.options" :key="item.srcId" :value="item.srcId"
                         :label="item.name"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="filter-item small-filter-item">
        <div class="item-label">
          节点状态
        </div>
        <div class="item-component">
          <div class="el-select-wrapper kpi-type-select-wrapper">
            <el-select v-model="filter.nodeStatus.value" clearable placeholder="请选择" filterable
                       @change="onNodeStatusChange">
              <el-option v-for="item in filter.nodeStatus.options" :key="item.code" :value="item.code"
                         :label="item.name" :class="$util.getRiskLevelBgColor(item.color)"></el-option>
            </el-select>
          </div>
        </div>
      </div>

      <div class="filter-item middle-filter-item">
        <div class="item-label">
          检查内容
        </div>
        <div class="item-component">
          <div class="el-input-wrapper">
            <el-input placeholder="请输入内容" v-model="filter.search.value" clearable @change="onSearchChange"></el-input>
          </div>
        </div>
      </div>

      <div class="filter-item small-filter-item">
        <div class="item-label">
          检查状态
        </div>
        <div class="item-component">
          <div class="el-select-wrapper kpi-type-select-wrapper">
            <el-select v-model="filter.searchStatus.value" clearable placeholder="请选择" filterable
                       @change="onSearchStatusChange">
              <el-option v-for="item in filter.searchStatus.options" :key="item.code" :value="item.code"
                         :label="item.name" :class="$util.getRiskLevelBgColor(item.color)"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="table-box" ref="table">
      <el-table :data="standardDangerData" :span-method="dangerSpanMethod" border height="360"
                header-cell-class-name="risk-table-header" cell-class-name="cell-class">
        <el-table-column label="#" prop="index" width="50" align="center">
        </el-table-column>
        <el-table-column prop="subSystemName" label="子系统" width="" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="processName" label="流程" width="">
        </el-table-column>
        <el-table-column prop="subProcessName" label="子流程" align="center">
          <template slot-scope="scope">
            <div class="danger-desc-box">
              <div class="danger-desc" @click="onSubProcessNameClick(scope.row)">
                {{ scope.row.subProcessName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="subProcessScore" label="子流程状态" width="" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div :class="$util.getRiskLevelColor(scope.row.subProcessLevelColor)">
              {{ scope.row.subProcessScore }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="subNodeName" label="节点" align="center">
          <!-- <template slot-scope="scope">
            <div :class="$util.getRiskLevelColor(scope.row.barrierStatusColor)">
              {{ scope.row.barrierStatus }}
            </div>
          </template> -->
        </el-table-column>
        <el-table-column prop="subNodeStatus" label="节点状态" width="" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div :class="$util.getRiskLevelColor(scope.row.subNodeLevelColor)">
              {{ scope.row.subNodeStatus }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="PROBLEM" label="检查内容" width="" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="SCORE" label="检查状态" width="" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div :class="$util.getRiskLevelColor(scope.row.LEVEL_COLOR)">
              {{ scope.row.SCORE }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="REF_REPORT_COUNT" label="关联任务单" width="" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div class="danger-desc-box">
              <div class="danger-desc" @click="takeReportData(scope.row)">
                {{ scope.row.REF_REPORT_COUNT }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="refReportVisble" :title="title" width="1000px">
      <el-table :data="reportData" border height="360"
                header-cell-class-name="risk-table-header" cell-class-name="cell-class">
        <el-table-column label="序号" prop="index" width="50" align="center">
        </el-table-column>
        <el-table-column prop="summary" label="关联工作单" width="200 px" :show-overflow-tooltip="true" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" target="_blank"
                     :href="$util.buildSmsActivityDetailUrl(scope.row.activityId)">
              {{ scope.row.summary }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="checkScore" label="检查评分" width="">
          <template slot-scope="scope">
            <div align="center" :class="calcRiskColor(scope.row.checkScore)">
              <b>{{ scope.row.checkScore }}</b>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="groupMembers" label="检查人员" width="200 px">
        </el-table-column>
        <el-table-column prop="inspectedUnitOrg" label="被检查单位" width="">
        </el-table-column>
        <el-table-column prop="inspectedPlace" label="检查地点" width="">
        </el-table-column>
        <el-table-column prop="completeDate" label="结案时间" width="100 px">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refReportVisble = false">取消</el-button>
      </span>
    </el-dialog>
  </div>


</template>

<script>
  import {getRequest, postRequest} from "../../../utils/request";
  import {postRequestSms} from "../../../utils/requestForSms";

  export default {
    props: {
      //系统
      system: String,
    },
    computed: {
      standardDangerData() {
        let index = 1;
        let merge = 1;
        this.tableData.forEach(function (item) {
          if (item.subNodeInfluence && item.subNodeFrequency && item.subNodeScore) {
            item.subNodeStatus = item.subNodeInfluence + "x" + item.subNodeFrequency + "=" + item.subNodeScore
          }
          if (parseInt(item.subSysIdMerge) > 0) merge = parseInt(item.subSysIdMerge);
          item.index = index;
          merge--;
          if (merge === 0)
            index++;
        })
        return this.tableData;
      }

    },
    data: function () {
      return {
        filter: {
          subProcess: {
            options: [],
            value: null
          },
          subProcessStatus: {
            options: [{"label": "20-25", "name": "20-25", "code": "20-25", "color": "RED"}
              , {"label": "15-16", "name": "15-16", "code": "15-16", "color": "ORANGE"}
              , {"label": "6-12", "name": "6-12", "code": "6-12", "color": "YELLOW"}
              , {"label": "1-5", "name": "1-5", "code": "1-5", "color": "GREEN"}
              , {"label": "无", "name": "无", "code": "NONE"}],
            value: null
          },
          node: {
            options: [],
            value: null
          },
          nodeStatus: {
            options: [{"label": "20-25", "name": "20-25", "code": "20-25", "color": "RED"}
              , {"label": "15-16", "name": "15-16", "code": "15-16", "color": "ORANGE"}
              , {"label": "6-12", "name": "6-12", "code": "6-12", "color": "YELLOW"}
              , {"label": "1-5", "name": "1-5", "code": "1-5", "color": "GREEN"}
              , {"label": "无", "name": "无", "code": "NONE"}],
            value: null
          },
          search: {
            value: null
          },
          searchStatus: {
            options: [{"label": "20-25", "name": "20-25", "code": "20-25", "color": "RED"}
              , {"label": "15-16", "name": "15-16", "code": "15-16", "color": "ORANGE"}
              , {"label": "6-12", "name": "6-12", "code": "6-12", "color": "YELLOW"}
              , {"label": "0-5", "name": "0-5", "code": "0-5", "color": "GREEN"}
              , {"label": "无", "name": "无", "code": "NONE"}],
            value: null
          }
        },
        tableData: [],
        permission: {
          process: false,
          ignore: false,
        },
        reportData: [],
        refReportVisble: false,
        title: "关联工作任务单"
      }
    },

    mounted() {
      this.buildTable();
      this.getSubProcessOptions();
      this.getNodeOptions();

    },
    methods: {
      buildTable: function () {
        postRequest("/dw-sup-workflow-problem/supWorkflowProblem/list", {
          subProcessId: this.filter.subProcess.value,
          subProcessStatusMin: this.filter.subProcessStatus.value != null ? this.filter.subProcessStatus.value === "NONE" ? 0 : this.filter.subProcessStatus.value.split("-")[0] : null,
          subProcessStatusMax: this.filter.subProcessStatus.value != null ? this.filter.subProcessStatus.value === "NONE" ? 0 : this.filter.subProcessStatus.value.split("-")[1] : null,
          nodeId: this.filter.node.value,
          nodeStatusMin: this.filter.nodeStatus.value != null ? this.filter.nodeStatus.value === "NONE" ? 0 : this.filter.nodeStatus.value.split("-")[0] : null,
          nodeStatusMax: this.filter.nodeStatus.value != null ? this.filter.nodeStatus.value === "NONE" ? 0 : this.filter.nodeStatus.value.split("-")[1] : null,
          search: this.filter.search.value,
          searchStatusMin: this.filter.searchStatus.value != null ? this.filter.searchStatus.value === "NONE" ? 0 : this.filter.searchStatus.value.split("-")[0] : null,
          searchStatusMax: this.filter.searchStatus.value != null ? this.filter.searchStatus.value === "NONE" ? 0 : this.filter.searchStatus.value.split("-")[1] : null,
          system: this.system
        }, {}, this.$refs.table).then(res => {
          this.tableData = res.data
        })
      },

      takeReportData: function (row) {
        postRequestSms("/query.do", {
          method: "problemRefActivityList",
          problemId: row.SRC_ID,
          checkType: "WORKFLOW",
          start: 0,
          length: -1,
          filterParams: "{}"
        }).then(res => {
          this.reportData = res.data.aaData;
          let index = 1;
          for (var i = 0; i < this.reportData.length; i++) {
            this.reportData[i].index = index;
            index++;
          }
          this.refReportVisble = true;
        });
      },
      onReportClick: function () {

      },
      onsubProcessChange: function () {
        this.getNodeOptions();
        this.buildTable();
      },
      onsubProcessStatusChange: function () {
        this.buildTable();
      },

      onNodeChange: function () {
        this.buildTable();
      },
      onNodeStatusChange: function () {
        this.buildTable();
      },
      onSearchChange: function () {
        this.buildTable();
      },
      onNodeStatusChange: function () {
        this.buildTable();
      },
      onSearchStatusChange: function () {
        this.buildTable();
      },
      onSubProcessNameClick(row) {
        this.$emit('update:subProcess', {id: row.SUB_PROCESS_ID, name: row.subProcessName});
      },
      getSubProcessOptions: function () {  //子流程
        getRequest("/dw-sup-sub-process/subProcess/getSubProcessByCompanyAndSystem"
          , {system: this.system})
          .then(res => {
            this.filter.subProcess.options = res.data;
          })
      },

      getSubProcessStatusOptions: function () {  //子流程状态

      },

      calcRiskColor: function (risk) {
        if (risk >= 1 && risk <= 5) {
          return "risk-level-bg-color-green"
        } else if (risk >= 6 && risk <= 12) {
          return "risk-level-bg-color-yellow"
        } else if (risk >= 15 && risk <= 16) {
          return "risk-level-bg-color-orange"
        } else if (risk >= 20 && risk <= 25) {
          return "risk-level-bg-color-red"
        } else {
          return "";
        }
      },

      getNodeOptions: function () {    //节点
        getRequest("/dw-sup-node/subNode/getSubNodeByCompanyAndSystem"
          , {
            system: this.system,
            subProcessId: this.filter.subProcess.value
          })
          .then(res => {
            this.filter.node.options = res.data;
          })
      },

      getNodeStatusOptions: function () {  //节点状态

      },

      getSearchStatusOptions: function () {    //状态

      },

      dangerSpanMethod({row, column, rowIndex, columnIndex}) {
        //危险源列合并
        if (columnIndex === 0 || columnIndex === 1) {
          var subSysIdMerge = parseInt(row.subSysIdMerge);
          if (subSysIdMerge > 0) {
            if (subSysIdMerge > 1) {
              return [subSysIdMerge, 1]
            } else {
              return [1, 1]
            }
          } else {
            return [0, 0];
          }
        }
        //风险等级列合并
        else if (columnIndex === 2) {
          var processIdMerge = parseInt(row.processIdMerge)
          if (processIdMerge) {
            if (processIdMerge > 1) {
              return [processIdMerge, 1]
            } else {
              return [1, 1]
            }
          } else {
            return [0, 0];
          }
        } else if (columnIndex === 3 || columnIndex === 4) {
          var subProcessIdMerge = parseInt(row.subProcessIdMerge)
          if (subProcessIdMerge) {
            if (subProcessIdMerge > 1) {
              return [subProcessIdMerge, 1]
            } else {
              return [1, 1]
            }
          } else {
            return [0, 0];
          }
        } else if (columnIndex === 5 || columnIndex === 6) {
          var nodeIdMerge = parseInt(row.nodeIdMerge)
          if (nodeIdMerge) {
            if (nodeIdMerge > 1) {
              return [nodeIdMerge, 1]
            } else {
              return [1, 1]
            }
          } else {
            return [0, 0];
          }
        }


      },

    },
    watch: {
      system() {
        this.buildTable();
        this.getNodeOptions();
        this.getSubProcessOptions();
      }
    }
  }
</script>

<style scoped lang="less">
  //过滤组件定制样式
  .filter-list {
    padding-top: 5px;

    .filter-item {
      .item-label {
        font-size: 13px;
        font-weight: bold;
      }

      .item-component {
        flex: 1;
      }
    }

    .filter-item:not(:first-child) {
      margin-left: 3.2%;
    }

    .middle-filter-item {
      width: 16%;
    }

    .small-filter-item {
      width: 12%;
    }

    //由于第2行只有5个组件，共4个margin，2.4*4=9.6，16*3+12+30.4=90.4
    .process-desc-filter-item {
      width: 30.4%;
    }

    .btn-filter-item {
      justify-content: end;
    }

  }

  .table-box {
    .danger-desc-box {
      display: flex;
      justify-content: space-between;
      //危险源描述
      .danger-desc {
        color: #4b99fe;

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/achievement/process/KeyProcessProblem.vue